import React from 'react';
import FuturisticHeader from './FuturisticHeader';
import FuturisticFooter from './FuturisticFooter';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-neu-bg">
      <FuturisticHeader />
      <main className="flex-grow pt-20">
        {children}
      </main>
      <FuturisticFooter />
    </div>
  );
};

export default Layout;